import request from '@/router/axios';

//获取盖章列表
export function sealList(query) {
  return request({
    url: '/api/brandContract/seal/page',
    method: 'get',
    params: query
  })
}
//盖章
export function clickSeal(query) {
  return request({
    url:'/api/brandContract/seal',
    method: 'get',
    params: query
  })
}